import React, { useMemo, useRef } from "react"
import { useMediaQuery } from "react-responsive"
import { Button } from "antd"
import { AutoSizer, CellMeasurer, CellMeasurerCache, List } from "react-virtualized"
import "./styles.scss"
import { LoadingWithLabel, Spinner } from "../Loading"
import moment from "moment"
import { AnswerBadge } from "../AnswerBadge"
import { AvatarIcon } from "../Avatar"
import { InfoBadge } from "../InfoBadge"
import { IndicatorBadge } from "../Badge"

export const TimeLineList = ({ data, loading, className }) => {
  const ref = useRef(null)

  const cache = useMemo(() => {
    return new CellMeasurerCache({
      //fixedWidth: true,
      defaultHeight: 120,
    })
  }, [data])

  const Row = ({ index, key, parent, style }) => {
    const row = data[index]

    const date = row.date && moment(row.date)
    const monthDate = date?.format("DD/MM")

    const renderAssistance = (act) => {
      return (
        <div className="activity-card-content-item">
          <span className="content-item-title">{act.title}</span>
          <div className="card-assistance-badge__container">
          <div className="card-assistance-badge-answer">
            {act.tags.map((tag) => (
              <AnswerBadge answer={tag.title} bold />
            ))}
          </div>
          <div className="content-item-badge">
            {act && act.additionalInfo?.map((info) => <InfoBadge info={info.title} bold />)}
          </div>
          </div>
        </div>
      )
    }

    const actionPlan = (act) => {
      return (
        <div className="activity-card-content-item">
          <span className="content-item-title">{act.title}</span>
          <div className="content-item-badge">
            {act && act.additionalInfo.length > 0 && act.additionalInfo?.map((info) => {
              return info.title !== "" && info.title !== null && <InfoBadge info={info.title} bold />
            })}
          </div>
        </div>
      )
    }

    const complementarForm = (act) => {
      return (
        <div className="activity-card-content-item">
          <span className="content-item-title">{act.title}</span>
          <div className="content-item-badge">
            {act && act.additionalInfo?.map((info) => <InfoBadge info={info.title} bold />)}
          </div>
        </div>
      )
    }

    const indicators = (act) => {
      return (
        <div className="activity-card-content-item">
          <div className="indicator-item">
            <IndicatorBadge indicatorValue={act?.value} />
            <span className="content-item-title">{act.title}</span>
          </div>
          <div className="content-item-badge">
            {act && act.additionalInfo?.map((info) => <InfoBadge info={info.title} bold />)}
          </div>
        </div>
      )
    }

    const getColorByActivity = (act) => {
      let color ="#00A800"
      if(act.type === "Plano de Ação"){
        color = "#FFC103"
      }
      else if(act.type === "Formulário Complementar"){
        color = "#FF8202"
      }
      else if(act.type === "Indicador"){
        color = "#4992D4"
      }

      return color
    }

    return (
      <>
        <CellMeasurer cache={cache} columnIndex={0} key={key} rowIndex={index} parent={parent}>
          <div style={{ ...style }} className="timeline-list-view-rows">
            <div className="timeline-list-view-row">
              <div className="time">
                <span className="month-date">{monthDate}</span>
                <span className="week-day">{row.weekDay}</span>
              </div>
              <div className="timeline-list-view-row__content">
                {row &&
                  row?.activities?.map((act) => (
                    <div className="activity">
                      <div
                        className="activity-card"
                        style={{ borderLeftColor: getColorByActivity(act) }}>
                        <div className="activity-card-header">
                          <span className="header-title">{act.type}</span>
                          <span className="header-time">{act.hour}h</span>
                        </div>

                        <div className="activity-card-content">
                          {act.type === "Atendimento" && renderAssistance(act)}
                          {act.type === "Plano de Ação" && actionPlan(act)}
                          {act.type === "Indicador" && indicators(act)}
                          {act.type === "Formulário Complementar" && complementarForm(act)}
                        </div>

                        {act?.producer?.id || act?.technician?.id && (
                            <>
                              <div className="activity-card-divide" />
                              <div className="activity-card-footer">
                                <div className="footer-user">
                                  <AvatarIcon
                                    name={act?.producer?.name || act?.technician?.name}
                                    size={32}
                                  />
                                  <span className="footer-user-name">{act?.producer?.name || act?.technician?.name}</span>
                                </div>
                                <div className="footer-project">
                                  {act.projects &&
                                    act.projects?.map((proj) => (
                                      <AnswerBadge answer={proj?.title} bold />
                                    ))}
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </CellMeasurer>
      </>
    )
  }

  return (
    <div className={`timeline-list-view${className ? ` ${className}` : ""}`}>
      <AutoSizer className="timeline-list-view__container">
        {({ height, width }) => (
          <>
            {loading ? (
              <div className="loading-content" style={{ height, width }}>
                <LoadingWithLabel sizeSpinner={32} labelLoading="Buscando formulários, aguarde..." colorSpinner="primary" />
              </div>
            ) : data?.length > 0 ? (
              <>
                <List
                  ref={ref}
                  deferredMeasurementCache={cache}
                  height={height}
                  rowCount={data?.length}
                  rowHeight={cache.rowHeight}
                  rowRenderer={Row}
                  width={width}
                  scrollToAlignment={"start"}
                  scrollToIndex={0}
                  innerElementType="ul"
                  className="timeline-list-view-scroll"></List>
              </>
            ) : (
              <div className="timeline-empty" style={{ height, width }}>
                <h3>
                  Não há formulários para o período e ou data informados
                  <br></br>
                  tente novamente
                </h3>
              </div>
            )}
          </>
        )}
      </AutoSizer>
    </div>
  )
}
